import { useQuery } from '@tanstack/react-query';
import Api from '../api/Api';
import useAuthStore from '../store/authStore';
import { QUERY_KEYS } from './queryKeys';

export const useSearchDatasetBriefs = (keyword: string) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  const trimmedKeyword = keyword.trim();
  const isSearching = trimmedKeyword.length > 0;

  const regularSearchParams = { keyword: trimmedKeyword, includeGlobal: false };
  const fweSearchParams = { keyword: trimmedKeyword, includeGlobal: false, vas: 'fwe' };

  const regularSearchQuery = useQuery({
    queryKey: [QUERY_KEYS.dataset.datasetBriefsSearch, regularSearchParams],
    queryFn: () => Api.search.dataSetBriefs(regularSearchParams),
    enabled: isSearching && Boolean(Api?.configData),
    staleTime: 0,
  });

  const fweSearchQuery = useQuery({
    queryKey: [QUERY_KEYS.dataset.datasetBriefsFweSearch, fweSearchParams],
    queryFn: () => Api.search.dataSetBriefs(fweSearchParams),
    enabled: isSearching && isAuthenticated(),
    staleTime: 0,
  });

  return {
    isSearching,
    isLoading: regularSearchQuery.isFetching || fweSearchQuery.isFetching,
    results: [...(regularSearchQuery.data ?? []), ...(fweSearchQuery.data ?? [])],
  };
};
